import { TFunction } from 'i18next';
import * as yup from 'yup';

export const authFormSchema = (t: TFunction) =>
  yup.object({
    username: yup.string().required(t('this_field_is_required')),
    password: yup.string().required(t('this_field_is_required')),
  });

export type AuthFormValues = yup.InferType<ReturnType<typeof authFormSchema>>;
